/* eslint-disable no-restricted-syntax */
import DashboardBody from '../components/dashboard/dashboardBody';
import BaseUrls from '../utils/baseUrls';

const Dashboard = () => (
    <DashboardBody theme={BaseUrls.getkey()} />
);

export default Dashboard;